import { Checkbox, FormControlLabel } from "@mui/material";
import { t } from "i18next";
import { jwtDecode } from "jwt-decode";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { actions } from "../../../../../../app/appSlice";
import CoreButton from "../../../../../../app/core/components/CoreButton/CoreButton";
import StudioFilter from "../../../../../../app/core/components/UserFilter/StudioFilter";
import {
  useConsentTermsMutation,
  useGetStudioExternalTenantIdQuery,
  useGetStudioTenantIdQuery,
} from "../../../../../../features/api/user/tenantApi";
import { doUserRegistration } from "../../../../../PublicLayout/RegistrationPage/registrationActions";

const SedeTenant = ({ tenant, onClose, onCloseTen, registration = {} }) => {
  const dispatch = useDispatch();
  const colorPrimary = useSelector((state) => state.app.primaryColor);

  const [studio, setStudio] = useState("");
  const [debouncedInputStudioValue, setDebouncedInputStudioValue] =
    useState("");
  const [consentUno, setConsentUno] = useState(false);
  const [consentDue, setConsentDue] = useState(false);
  const [consentTre, setConsentTre] = useState(false);

  const [consetTerms] = useConsentTermsMutation();

  const isRegistrationNotEmpty =
    registration && Object.keys(registration).length > 0;

  const { data: getSede } = useGetStudioTenantIdQuery(
    { query: debouncedInputStudioValue, tenantId: tenant?.tenantId },
    {
      skip: !tenant?.tenantId || isRegistrationNotEmpty,
    }
  );

  const { data: getSedeExternal } = useGetStudioExternalTenantIdQuery(
    {
      query: debouncedInputStudioValue,
      tenantId: tenant?.tenantId,
    },
    {
      skip: !tenant?.tenantId,
    }
  );

  const handleConsentTerms = async () => {
    const toastId = toast.loading(t("Processing"));

    try {
      const body = {
        tenantId: tenant.tenantId,
        consent1: consentUno,
        consent2: consentDue,
        consent3: consentTre,
      };

      if (studio.id) {
        body.studioId = studio.id;
        dispatch(
          actions.setStudioId({
            studioId: studio.id,
          })
        );
      }

      const responseConsentTerms = await consetTerms(body);

      if (responseConsentTerms.data.Result !== 1) {
        toast.update(toastId, {
          render: responseConsentTerms.data.Exception || t("NotConsentTerms"),
          type: "error",
          isLoading: false,
          autoClose: 1500,
        });
        return;
      }

      toast.update(toastId, {
        render: `${t("ConsentTerms")}`,
        type: "success",
        isLoading: false,
        autoClose: 1500,
      });

      const JWT = responseConsentTerms.data.Data.updatedJwt;
      handleDispatchOnSuccess(JWT);
      onClose();
      onCloseTen();
    } catch (error) {
      console.error(error);
      toast.update(toastId, {
        render: t("NotConsentTerms"),
        type: "error",
        isLoading: false,
        autoClose: 1500,
      });
    }
  };

  const handleDispatchOnSuccess = (updatedJwt) => {
    const decodeJWT = jwtDecode(updatedJwt);
    setTimeout(() => {
      dispatch(
        actions.updateAppState({
          accessToken: updatedJwt,
          ...decodeJWT,
          // selectedTenantId: tenant.tenantId,
        })
      );
    }, 2000);
  };

  const handleSubmit = () => {
    const userData = {
      name: registration.name,
      surname: registration.surname,
      email: registration.email,
      fiscalCode: registration.cf,
      password: registration.password,
      privacy: true,
      gdpr: true,
      thirdParty: true,
      tenantId: tenant.tenantId,
      consent1: consentUno,
      consent2: consentDue,
      consent3: consentTre,
      studioId: studio.id,
    };

    dispatch(doUserRegistration(userData)).then((res) => {
      if (res?.payload?.Result !== 1) {
        toast.error(`Errore: ${res?.payload?.Exception}`);
      } else {
        toast.success(t("RegistrationUser"));
      }
    });
  };

  return (
    <div className="w-full flex justify-center">
      <div className="w-3/4">
        <div>
          <h2>Seleziona Sede</h2>

          <div className="flex flex-col">
            <p className="m-2 ">{t("Sede")}</p>
            <StudioFilter
              name="studio"
              isRequired={true}
              selectedUser={studio}
              setSelectedUser={(v) => {
                setStudio(v);
              }}
              usersList={
                isRegistrationNotEmpty ? getSedeExternal?.Data : getSede?.Data
              }
              setDebouncedInputUserValue={setDebouncedInputStudioValue}
            />
          </div>
        </div>

        <div>
          <h4 className="text-primary mb-0">{tenant?.name}</h4>
          <h2 className="m-0">Termini e condizioni</h2>
          <p>{tenant?.privacy}</p>
        </div>

        <div className="w-full flex flex-col justify-start mt-5">
          <FormControlLabel
            className="pt-3"
            required
            label={t("Consent")}
            control={
              <Checkbox
                checked={consentUno}
                onChange={() => setConsentUno(!consentUno)}
              />
            }
          />

          <FormControlLabel
            className="pt-3"
            required
            label={t("Consent2")}
            control={
              <Checkbox
                checked={consentDue}
                onChange={() => setConsentDue(!consentDue)}
              />
            }
          />

          <FormControlLabel
            className="pt-3"
            required
            label={t("Consent3")}
            control={
              <Checkbox
                checked={consentTre}
                onChange={() => setConsentTre(!consentTre)}
              />
            }
          />
        </div>
        <div className="mt-20 w-full flex justify-around">
          <CoreButton
            style={{ color: colorPrimary }}
            disabled={!(consentUno && consentDue && consentTre && studio)}
            className={"btn-round"}
            variant="contained"
            testo={t("Register")}
            onClick={isRegistrationNotEmpty ? handleSubmit : handleConsentTerms}
          />
        </div>
      </div>
    </div>
  );
};

export default SedeTenant;
